// extracted by mini-css-extract-plugin
export var dowmloadFormFile = "component-module--dowmloadFormFile--9bed8";
export var formHeaderImage = "component-module--formHeaderImage--9f86a";
export var previewImage = "component-module--previewImage--58b74";